import { Post, postJSON } from "../utils/http.js"

export function goCheckout(params) {
  return postJSON("/api/order/goCheckout", params, {
    loading: true,
    shouldErrorHandler: true
  })
}

export function orderSubmit(params) {
  return postJSON("/api/order/orderSubmit", params, {
    loading: true,
    shouldErrorHandler: true
  })
}

export function goCheckoutV2(params, config = { loading: true, shouldErrorHandler: true }) {
  return postJSON("/api/order/goCheckout/v2", params, config)
}
